
import { defineComponent, reactive, toRefs, watch } from 'vue'
export default defineComponent({
  name: '',
  emits: ['toggleTmRulePopup'],
  props: {
    gameRule: {
      type: String,
      default: `
      1.本次活动中红包领取时间截止至2021年12月31日24点；<br/>
      2.订单同步为次日，例如12日下的订单，在13日24：00前
      `,
    },
    isShowTmRulePopup: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const data = reactive({})
    watch(
      () => props.isShowTmRulePopup,
      (nVal: any) => {
        if (nVal === true) {
          document.body.style.overflow = 'hidden'
          document.body.style.position = 'fixed'
        } else {
          document.body.style.overflow = 'scroll'
          document.body.style.position = 'static'
        }
      },
    )
    const methods = {
      toggleTmRulePopup(isShowTmRulePopup: boolean) {
        emit('toggleTmRulePopup', { isShowTmRulePopup })
      },
    }
    return {
      ...toRefs(data),
      ...methods,
    }
  },
})
